import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	email: {
		'id': 'surveyFooter.email',
		'defaultMessage': 'official@stog.io',
	},
	copyright: {
		'id': 'surveyFooter.copyright',
		'defaultMessage': 'The survey is&nbsp;conducted anonymously.<br/>StogIO&nbsp;Copyright&nbsp;&copy;&nbsp;2018. All rights reserved.',
	},
});


// WEBPACK FOOTER //
// ./src/components/SurveyFooter/messages.js